<div class="faq-accordion" #faqAccordion data-section-id="faq-accordion-section" data-section-name="FAQ Accordion">
  <div class="faq-accordion__container">

    <div class="row align-items-center mt-4">
  <div class="col-md-12">
    <div class="container">
      <div class="page-site">
        <div class="row pt-10">
          <div class="col-sm-12 col-md-12 col-lg-12">

            <div id="accordion">
              <div class="card">

                <!-- Pregunta principal -->
                <div class="card-header" id="heading0" style="background:#683DF2;">
                  <h5 class="mb-0" style="padding: 0;">
                    <button
                      class="btn btn-preguntas-custom"
                      style="color: white;"
                      aria-controls="collapse0"
                      aria-expanded="false"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse0"
                    >
                      <img
                        src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                        alt="desplegable"
                        class="fr-fic fr-dii"
                        style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;"
                      >
                      ¿Qué es Unipay?
                    </button>
                  </h5>
                </div>

                <div
                  id="collapse0"
                  class="collapse"
                  aria-labelledby="heading0"
                  data-bs-parent="#accordion"
                >
                  <div class="card-body">

                    <div class="card">

                      <!-- Subpregunta 1 -->
                      <div class="card-header" id="heading0_1">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-preguntas-custom collapsed"
                            aria-controls="collapse0_1"
                            aria-expanded="false"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse0_1"
                          >
                            ¿Qué es Unipay?
                          </button>
                        </h5>
                      </div>

                      <div
                        id="collapse0_1"
                        class="collapse"
                        aria-labelledby="heading0_1"
                      >
                        <div class="card-body box3-preguntas">
                          <p>
                            Unipay es una Tarjeta de Crédito 100% digital. No necesitas un plástico para usarla. Puedes pagar con tu huella, simple, cómodo y seguro, y puedes usar la App Unipay para autorizar tus compras presenciales en todos nuestros supermercados.​
                          </p>
                        </div>
                      </div>

                      <!-- Subpregunta 2 -->
                      <div class="card-header" id="heading0_2">
                        <h5 class="mb-0">
                          <button
                            class="btn btn-preguntas-custom collapsed"
                            aria-controls="collapse0_2"
                            aria-expanded="false"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse0_2"
                          >
                            ¿Qué puedo hacer con Unipay?
                          </button>
                        </h5>
                      </div>

                      <div
                        id="collapse0_2"
                        class="collapse"
                        aria-labelledby="heading0_2"
                      >
                        <div class="card-body box3-preguntas">
                          <p>
                            Con Unipay puedes pagar tus compras en los supermercados: Unimarc, Super 10, Alvi y en Unimarc.cl. Además, es la única tarjeta de crédito con la que puedes pagar todas tus cuentas a través del portal de pagos Unired.cl
                          </p>

                          <p>
                            Con tu Unipay puedes pedir Avances en Efectivo directamente en las cajas de los supermercados o también lo puedes solicitar en el Whatsapp por transferencia a tu cuenta bancaria y acceder a Súper Avances con transferencia directo a tu cuenta bancaria.
                          </p>
                        </div>
                      </div>

                    </div><!-- /.card interno -->

                  </div><!-- /.card-body -->
                </div><!-- /#collapse0 -->

              </div><!-- /.card -->


              <div class="card">
    <div class="card-header" id="heading2" style="background:#683DF2;">
        <h5 class="mb-0">
            <button aria-controls="collapse2"
                    style="color: white;"
                    aria-expanded="false"
                    class="btn btn-preguntas-custom collapsed"
                    data-bs-target="#collapse2"
                    data-bs-toggle="collapse">
                <img alt="desplegable"
                     src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                     class="fr-fic fr-dii"
                     data-filetype="image/png"
                     style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;">
                ¿Dónde pido mi Unipay?
            </button>
        </h5>
    </div>

    <div aria-labelledby="heading2"
         class="collapse"
         data-bs-parent="#accordion"
         id="collapse2">

        <div class="card-body">

            <div class="card">

                <div class="card-header" id="heading2_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse2_1"
                                aria-expanded="false"
                                class="btn btn-preguntas-custom collapsed"
                                data-bs-target="#collapse2_1"
                                data-bs-toggle="collapse">
                            ¿Cómo puedo obtener mi Unipay?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading2_1"
                     class="collapse"
                     id="collapse2_1">

                    <div class="card-body box3-preguntas">
                        <p>
                            Puedes solicitarla<a href="https://www.unipay.cl/autoatencion-ptoventa/validar-identidad?utm_source=Digital&utm_medium=Pagina_Unipay&utm_campaign=PF"> Apretando Acá. </a>Solo necesitas tener tu cédula y celular a mano. Llena el formulario y sigue las instrucciones paso a paso. Si prefieres ayuda en el proceso, llama al 600 390 9000, uno de nuestros ejecutivos estará listo para atenderte.
                        </p>
                        <p>
                            Recuerda que el otorgamiento de la Tarjeta Unipay queda sujeto a la evaluación crediticia, conforme con los requisitos previa y públicamente establecidos, disponibles en www.unipay.cl
                        </p>
                    </div>

                </div> <!-- collapse2_1 -->

            </div> <!-- card interno -->

        </div> <!-- card-body -->

    </div> <!-- collapse2 -->

</div> <!-- card principal -->



<div class="card">
  <div class="card-header" id="heading3" style="background:#683DF2;">
    <h5 class="mb-0">
      <button
        class="btn btn-preguntas-custom collapsed"
        style="color: white;"
        aria-controls="collapse3"
        aria-expanded="false"
        data-bs-toggle="collapse"
        data-bs-target="#collapse3"
      >
        <img src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
             alt="desplegable"
             class="fr-fic fr-dii"
             style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;">
        ¿Cómo uso mi Unipay? ¿Cómo funciona?
      </button>
    </h5>
  </div>

  <div id="collapse3"
       class="collapse"
       aria-labelledby="heading3"
       data-bs-parent="#accordion">

    <div class="card-body">
      <div class="card">

        <!-- Subpregunta 1 -->
        <div class="card-header" id="heading3_1">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_1"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_1"
            >
              ¿Cuáles son los requisitos para solicitar Unipay?
            </button>
          </h5>
        </div>

        <div id="collapse3_1"
             class="collapse"
             aria-labelledby="heading3_1">
          <div class="card-body box3-preguntas">
            <ul>
              <li>Tener al menos 30 años y no más de 74 años y 364 días.</li>
              <li>Contar con la cédula de identidad vigente y sin bloqueo.</li>
              <li>Ingresos acreditables, recurrentes y estables.</li>
              <li>Nacionalidad chilena o extranjera con permanencia definitiva acreditada durante más de 5 años y con contrato de trabajo a término indefinido.</li>
              <li>Acreditación de domicilio.</li>
              <li>Contar con teléfono celular activo.</li>
              <li>Cumplir con el nivel de aprobación contemplado en el mecanismo de evaluación o análisis de riesgo utilizado por Unicard.</li>
              <li>No tener morosidades ni protestos vigentes.</li>
              <li>Ningún registro, ni haber registrado incumplimiento de pago o castigos en Unicard.</li>
              <li>No haber sido rechazado para la solicitud de la tarjeta Unicard en los 6 meses previos a la fecha de la solicitud.</li>
            </ul>
          </div>
        </div>

        <!-- Subpregunta 2 -->
        <div class="card-header" id="heading3_2">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_2"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_2"
            >
              ¿Debo activarla antes de usarla?
            </button>
          </h5>
        </div>

        <div id="collapse3_2"
             class="collapse"
             aria-labelledby="heading3_2">
          <div class="card-body box3-preguntas">
            <p>No es necesario que actives tu Unipay. Una vez completado el proceso de apertura, queda lista para usar de inmediato en forma presencial en los supermercados Unimarc, Super 10 y Alvi, sólo debes pagar con tu huella o tu código de compras de la App Unipay.</p>
          </div>
        </div>

        <!-- Subpregunta 3 -->
        <div class="card-header" id="heading3_8">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_8"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_8"
            >
              ¿Cómo puedo comprar con Unipay en canales digitales?
            </button>
          </h5>
        </div>

        <div id="collapse3_8"
             class="collapse"
             aria-labelledby="heading3_8">
          <div class="card-body box3-preguntas">
            <ul>
              <li>Si ya tienes tu Unipay, primero debes realizar una compra presencial usando tu huella en cualquier supermercado, quedando habilitada al día siguiente de realizada la compra.</li>
              <li>Si eres cliente nuevo, debes esperar 3 días hábiles contados desde el día siguiente al que obtuviste tu Unipay. Enviaremos un mensaje a tu celular o a tu correo electrónico registrado informando la activación.</li>
              <li>Si presentas dudas en este proceso, llámanos al 600 390 9000.</li>
            </ul>
          </div>
        </div>

        <!-- Subpregunta 4 -->
        <div class="card-header" id="heading3_3">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_3"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_3"
            >
              ¿Debo registrar mi huella para usar Unipay?
            </button>
          </h5>
        </div>

        <div id="collapse3_3"
             class="collapse"
             aria-labelledby="heading3_3">
          <div class="card-body box3-preguntas">
            <p>No, usamos un servicio que ya tiene tu huella registrada (el mismo que utilizas para pagar tus bonos). </p>
            <p>Con Unipay no necesitas llevar tu billetera al supermercado, es práctico y seguro.</p>   
          </div>
        </div>

        <!-- Subpregunta 5 -->
        <div class="card-header" id="heading3_4">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_4"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_4"
            >
              ¿Cómo pago con Unipay?
            </button>
          </h5>
        </div>

        <div id="collapse3_4"
             class="collapse"
             aria-labelledby="heading3_4">
          <div class="card-body box3-preguntas">
            <p>Pagar con Unipay  es simple, cómodo y seguro ¡Sólo necesitas tu huella o tu App Unipay!</p>
            <p>Para compras presenciales en los supermercados debes dictar tu Rut en caja, colocas tu huella en el lector de huella o entregas tu código de compras disponible en la App Unipay para confirmar el pago y ¡listo!</p>
            <p>Para compras por internet debes seleccionar Unipay como método de pago, ingresas tu RUT y recibirás una clave en tu celular para confirmar el pago y ¡listo!</p>
          </div>
        </div>

        <!-- Subpregunta 6 -->
        <div class="card-header" id="heading3_5">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_5"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_5"
            >
              ¿Puedo comprar en 1 o más cuotas con la Tarjeta?
            </button>
          </h5>
        </div>

        <div id="collapse3_5"
             class="collapse"
             aria-labelledby="heading3_5">
          <div class="card-body box3-preguntas">
          <p>Puedes pagar en 1 cuota las compras o bien elegir el plan que más te acomode desde 3 hasta 9 cuotas con Unipay en canales presenciales.</p>
          <p>Los avances en efectivo los puedes pagar desde 1 hasta 12 cuotas.</p>
          </div>
        </div>

        <!-- Subpregunta 7 -->
        <div class="card-header" id="heading3_6">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_6"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_6"
            >
              ¿Cómo funciona el pago con huella en caja?
            </button>
          </h5>
        </div>

        <div id="collapse3_6"
             class="collapse"
             aria-labelledby="heading3_6">
          <div class="card-body box3-preguntas">
            <p>Indicas medio de pago Unipay, dictas tu Rut, eliges cuotas, pones tu huella y listo.</p>
          </div>
        </div>

        <!-- Subpregunta 8 -->
        <div class="card-header" id="heading3_7">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-controls="collapse3_7"
              aria-expanded="false"
              data-bs-toggle="collapse"
              data-bs-target="#collapse3_7"
            >
              ¿Cómo puedo pagar si no funciona mi huella? 
            </button>
          </h5>
        </div>

        <div id="collapse3_7"
             class="collapse"
             aria-labelledby="heading3_7">
          <div class="card-body box3-preguntas">
            <p>Puedes pagar con tu código de compras disponible en la App Unipay, la cual puedes descargar en App Store o Google Play</p>
            <p>También puedes solicitar una tarjeta física llamando al 600 390 9000.</p>
          </div>
        </div>

      </div> <!-- card interno -->
    </div> <!-- card-body -->

  </div> <!-- collapse3 -->
</div> <!-- CARD PRINCIPAL -->


<div class="card">
  <div class="card-header" id="heading4" style="background:#683DF2;">
    <h5 class="mb-0">
      <button
        style="color: white;"
        aria-controls="collapse4"
        aria-expanded="false"
        class="btn btn-preguntas-custom collapsed"
        data-bs-target="#collapse4"
        data-bs-toggle="collapse"
      >
        <img
          alt="desplegable"
          src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
          class="fr-fic fr-dii"
          style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;"
        >
        ¿Cuáles son los canales de atención de Unipay?
      </button>
    </h5>
  </div>

  <div
    id="collapse4"
    class="collapse"
    aria-labelledby="heading4"
    data-bs-parent="#accordion"
  >
    <div class="card-body">

      <div class="card">

        <!-- Subpregunta 1 -->
        <div class="card-header" id="heading4_1">
          <h5 class="mb-0">
            <button
              aria-controls="collapse4_1"
              aria-expanded="false"
              class="btn btn-preguntas-custom collapsed"
              data-bs-target="#collapse4_1"
              data-bs-toggle="collapse"
            >
              ¿Cuáles son los canales de atención de Unipay?
            </button>
          </h5>
        </div>

        <div
          id="collapse4_1"
          class="collapse"
          aria-labelledby="heading4_1"
        >
          <div class="card-body box3-preguntas">
            <h6>Puedes comunicarte con nosotros a:</h6>
            <ul>
              <li>Whatsapp +569 58123297 para conocer tu cupo, últimos movimientos, estado de cuenta y otros.</li>
              <li>Contact Center: 600 390 9000 para consultas, solicitudes, reclamos.</li>
              <li>Fono Emergencia: 800 393030, sólo para bloqueo de la tarjeta por robo, pérdida.</li>
              <li>Correo Electrónico: servicioalcliente&#64;unipay.cl</li>
            </ul>
          </div>
        </div>

        <!-- Subpregunta 2 -->
        <div class="card-header" id="heading4_2">
          <h5 class="mb-0">
            <button
              aria-controls="collapse4_2"
              aria-expanded="false"
              class="btn btn-preguntas-custom collapsed"
              data-bs-target="#collapse4_2"
              data-bs-toggle="collapse"
            >
              ¿Dónde puedo obtener información de mi estado de cuenta, consultar mi cupo, últimos movimientos?
            </button>
          </h5>
        </div>

        <div
          id="collapse4_2"
          class="collapse"
          aria-labelledby="heading4_2"
        >
          <div class="card-body box3-preguntas">
            <ul>
              <li>A través de WhatsApp +569 58123297.</li>
              <li>Directamente en nuestro Contact Center 600 390 9000.</li>
              <li>En tu App Unipay puedes encontrar tu cupo disponible, monto facturado y montos de Avance o Super Avance.​</li>
            </ul>
          </div>
        </div>

        <!-- Subpregunta 3 -->
        <div class="card-header" id="heading4_3">
          <h5 class="mb-0">
            <button
              aria-controls="collapse4_3"
              aria-expanded="false"
              class="btn btn-preguntas-custom collapsed"
              data-bs-target="#collapse4_3"
              data-bs-toggle="collapse"
            >
              ¿Qué debo hacer en caso de extravío y/o robo de mi tarjeta?
            </button>
          </h5>
        </div>

        <div
          id="collapse4_3"
          class="collapse"
          aria-labelledby="heading4_3"
        >
          <div class="card-body box3-preguntas">
            <p>
              Debes bloquear inmediatamente a través de nuestro WhatsApp +569 58123297 seleccionando la opción 6 y seguir las instrucciones
              o dar aviso llamando al 600 390 9000 opción 5 o al Fono Emergencia 800 393030 opción 5.
            </p>
          </div>
        </div>

      </div><!-- card interno -->

    </div><!-- card-body -->
  </div><!-- collapse4 -->
</div>

<div class="card">
  <div class="card-header" id="heading5" style="background:#683DF2;">
    <h5 class="mb-0">
      <button
        style="color: white;"
        class="btn btn-preguntas-custom collapsed"
        aria-expanded="false"
        aria-controls="collapse5"
        data-bs-toggle="collapse"
        data-bs-target="#collapse5"
      >
        <img
          src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
          alt="desplegable"
          class="fr-fic fr-dii"
          data-filetype="image/png"
          style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;"
        >
        ¿Qué costos tiene Unipay?
      </button>
    </h5>
  </div>

  <div
    id="collapse5"
    class="collapse"
    aria-labelledby="heading5"
    data-bs-parent="#accordion"
  >
    <div class="card-body">
      <div class="card">

        <!-- Subpregunta 1 -->
        <div class="card-header" id="heading5_1">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-expanded="false"
              aria-controls="collapse5_1"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5_1"
            >
              ¿Cuál es el monto de la comisión de administración mensual?
            </button>
          </h5>
        </div>

        <div
          id="collapse5_1"
          class="collapse"
          aria-labelledby="heading5_1"
        >
          <div class="card-body box3-preguntas">
            <p>
              Debes revisar en tu Estado de Cuenta, ahí se informa el monto de la Comisión de Administración
              de acuerdo con la fecha en que firmaste tu contrato.
            </p>
          </div>
        </div>

        <!-- Subpregunta 2 -->
        <div class="card-header" id="heading5_2">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-expanded="false"
              aria-controls="collapse5_2"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5_2"
            >
              ¿Dónde puedo ver los intereses y comisiones de la tarjeta?
            </button>
          </h5>
        </div>

        <div
          id="collapse5_2"
          class="collapse"
          aria-labelledby="heading5_2"
        >
          <div class="card-body box3-preguntas">
            <p>
              Lo puedes ver en el siguiente link:
              <a href="https://www.unipay.cl/api/descargaArchivo/Pizarra.pdf" target="_blank">Ver Pizarra</a>.
            </p>
          </div>
        </div>

        <!-- Subpregunta 3 -->
        <div class="card-header" id="heading5_3">
          <h5 class="mb-0">
            <button
              class="btn btn-preguntas-custom collapsed"
              aria-expanded="false"
              aria-controls="collapse5_3"
              data-bs-toggle="collapse"
              data-bs-target="#collapse5_3"
            >
              ¿Cuáles son los costos asociados a Unipay?
            </button>
          </h5>
        </div>

        <div
          id="collapse5_3"
          class="collapse"
          aria-labelledby="heading5_3"
        >
          <div class="card-body box3-preguntas">

            <h6>El único costo que Unipay te puede cobrar es:</h6>

            <ul>
              <li>
                Costo de Administración mensual: debes revisar en tu Estado de Cuenta,
                ahí se informa el monto de la Comisión de Administración de acuerdo con
                la fecha en que firmaste tu contrato.
              </li>
              <li>Unipay no te cobra comisión por Avances y Súper Avances.</li>
              <li>
                Los seguros son 100% voluntarios. Jamás te pediremos contratar un seguro
                para habilitar la cuenta.
              </li>
            </ul>

          </div>
        </div>

      </div> <!-- card interno -->
    </div> <!-- card-body -->
  </div> <!-- collapse5 -->
</div> <!-- card principal -->


<div class="card">
    <div class="card-header" id="heading6" style="background:#683DF2;">
        <h5 class="mb-0">
            <button style="color: white;"
                aria-controls="collapse6"
                aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse6"
                data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii"
                    data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                Sobre la deuda con Unipay
            </button>
        </h5>
    </div>

    <div id="collapse6" class="collapse" aria-labelledby="heading6" data-bs-parent="#accordion">
        <div class="card-body">
            <div class="card">

                <!-- 6.1 -->
                <div class="card-header" id="heading6_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse6_1"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse6_1"
                            data-bs-toggle="collapse">
                            ¿Dónde puedo pagar mi estado de cuenta?
                        </button>
                    </h5>
                </div>
                <div id="collapse6_1" class="collapse" aria-labelledby="heading6_1">
                    <div class="card-body box3-preguntas">
                        <ul>
                            <li>En todas las cajas de Supermercados Unimarc, Super 10 y Alvi sólo dictando tu Rut. Pagos en línea, sólo en efectivo.</li>
                            <li>En www.unipay.cl, podrás elegir pagar a través de EtPay, directamente desde tu banco y a través de Unired.cl o WebPay Plus.</li>
                            <li>También puedes ingresar directamente en www.unired.cl ingresando con tu número de Rut, donde pagarás con tarjetas de débito y crédito.</li>
                            <li>Pagos en todas las cajas de Sucursales Servipag sólo dictando tu Rut y sólo en efectivo. Estos pagos se registran en tu cuenta Unipay con la fecha en que se realiza la operación y los cupos serán liberados en la cuenta a las 48 hrs. de realizado el pago.</li>
                        </ul>
                    </div>
                </div>

                <!-- 6.2 -->
                <div class="card-header" id="heading6_2">
                    <h5 class="mb-0">
                        <button aria-controls="collapse6_2"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse6_2"
                            data-bs-toggle="collapse">
                            ¿Cuál es mi fecha de pago?
                        </button>
                    </h5>
                </div>
                <div id="collapse6_2" class="collapse" aria-labelledby="heading6_2">
                    <div class="card-body box3-preguntas">
                        <p>La fecha de pago es distinta para cada cliente. Esta la eliges al momento de contratar tu Unipay.
                            Puedes consultar esta fecha en tu contrato.</p>
                        <p>También puedes consultar en el WhatsApp +569 58123297 (fecha de vencimiento de pago) y en tu estado de cuenta que recibes a tu mail.</p>
                    </div>
                </div>

                <!-- 6.3 -->
                <div class="card-header" id="heading6_3">
                    <h5 class="mb-0">
                        <button aria-controls="collapse6_3"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse6_3"
                            data-bs-toggle="collapse">
                            ¿Cuáles son las opciones para pagar mi Estado de Cuenta?
                        </button>
                    </h5>
                </div>
                <div id="collapse6_3" class="collapse" aria-labelledby="heading6_3">
                    <div class="card-body box3-preguntas">
                        <ul>
                            <li>Puedes pagar el monto total facturado.</li>
                            <li>Puedes pagar el monto mínimo facturado, teniendo en consideración que se generarán intereses por la diferencia entre el monto total facturado y el monto pagado, el que deberás pagar en tu siguiente facturación.</li>
                        </ul>
                        <p>Recuerda que al pagar el monto mínimo evitas caer en mora y seguir usando la tarjeta según la línea de crédito disponible.</p>
                    </div>
                </div>

                <!-- 6.4 -->
                <div class="card-header" id="heading6_4">
                    <h5 class="mb-0">
                        <button aria-controls="collapse6_4"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse6_4"
                            data-bs-toggle="collapse">
                            ¿Qué debo hacer si mi pago no está aplicado en mi cuenta?
                        </button>
                    </h5>
                </div>
                <div id="collapse6_4" class="collapse" aria-labelledby="heading6_4">
                    <div class="card-body box3-preguntas">
                        <p>Debes escribir a la casilla servicioalcliente&#64;unipay.cl adjuntando la copia del comprobante de pago emitido.</p>
                    </div>
                </div>

                <!-- 6.5 -->
                <div class="card-header" id="heading6_5">
                    <h5 class="mb-0">
                        <button aria-controls="collapse6_5"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse6_5"
                            data-bs-toggle="collapse">
                            ¿Puedo pagar mi deuda anticipadamente?
                        </button>
                    </h5>
                </div>
                <div id="collapse6_5" class="collapse" aria-labelledby="heading6_5">
                    <div class="card-body box3-preguntas">
                        <p>Si deseas realizar un pago total de tu deuda, deberás siempre solicitar una Liquidación de Prepago a nuestro email servicioalcliente&#64;unipay.cl o también nos puedes llamar al 600 390 9000.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header" id="heading11" style="background:#683DF2;">
        <h5 class="mb-0">
            <button style="color: white;"
                aria-controls="collapse11"
                aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse11"
                data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii"
                    data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                Otras dudas con Unipay
            </button>
        </h5>
    </div>

    <div id="collapse11" class="collapse" aria-labelledby="heading11" data-bs-parent="#accordion">
        <div class="card-body">
            <div class="card">

                <!-- 11.1 -->
                <div class="card-header" id="heading11_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse11_1"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse11_1"
                            data-bs-toggle="collapse">
                            ¿Cómo puedo actualizar mis datos personales?
                        </button>
                    </h5>
                </div>
                <div id="collapse11_1" class="collapse" aria-labelledby="heading11_1">
                    <div class="card-body box3-preguntas">
                        <p>Llamando a nuestro Contact Center 600 390 9000. Para hacer este proceso debes tener tu cédula de identidad a mano y al realizar el cambio de datos de contacto, por tu seguridad, quedará bloqueada la opción de compras online (Unimarc.cl, App Unimarc o Unired.cl)​.</p>
                        <p>Consulta cómo volver a habilitar esta alternativa en caso que lo requieras.</p>
                    </div>
                </div>

                <!-- 11.2 -->
                <div class="card-header" id="heading11_2">
                    <h5 class="mb-0">
                        <button aria-controls="collapse11_2"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse11_2"
                            data-bs-toggle="collapse">
                            ¿Cómo puedo cerrar mi tarjeta Unipay?
                        </button>
                    </h5>
                </div>
                <div id="collapse11_2" class="collapse" aria-labelledby="heading11_2">
                    <div class="card-body box3-preguntas">
                        <p>Para cerrar tu tarjeta debes llamar al Contact Center al 600 390 9000. Recuerda que Unipay solo tiene costos si la usas.</p>
                    </div>
                </div>

                <!-- 11.3 -->
                <div class="card-header" id="heading11_3">
                    <h5 class="mb-0">
                        <button aria-controls="collapse11_3"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse11_3"
                            data-bs-toggle="collapse">
                            ¿Dónde puedo pedir una nueva tarjeta en caso de deterioro?
                        </button>
                    </h5>
                </div>
                <div id="collapse11_3" class="collapse" aria-labelledby="heading11_3">
                    <div class="card-body box3-preguntas">
                        <p>Llamando a nuestro Contact Center 600 390 9000 podrás pedir una nueva tarjeta.</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="card">
    <div class="card-header" id="heading7" style="background:#683DF2;">
        <h5 class="mb-0">
            <button style="color: white;"
                aria-controls="collapse7"
                aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse7"
                data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii"
                    data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                ¿Cuáles son los beneficios con Unipay?
            </button>
        </h5>
    </div>

    <div id="collapse7" class="collapse" aria-labelledby="heading7" data-bs-parent="#accordion">
        <div class="card-body">
            <div class="card">

                <!-- 7.1 -->
                <div class="card-header" id="heading7_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse7_1"
                            aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse7_1"
                            data-bs-toggle="collapse">
                            ¿Dónde me entero de los beneficios con Unipay?
                        </button>
                    </h5>
                </div>
                <div id="collapse7_1" class="collapse" aria-labelledby="heading7_1">
                    <div class="card-body box3-preguntas">
                        <p>Revisa en www.unipay.cl o en nuestro Instagram <a href="https://www.instagram.com/unipay_cl?igsh=MXEzaWQ0anRkYml4eQ%3D%3D">&#64;unipay_cl</a> los descuentos y beneficios que tenemos para ti.​</p>
                    </div>
                </div>

             

            </div>
        </div>
    </div>
</div>


<div class="card">
    <div class="card-header" id="heading8" style="background:#683DF2;">
        <h5 class="mb-0">
            <button 
                style="color: white;" 
                class="btn btn-preguntas-custom collapsed" 
                data-bs-toggle="collapse" 
                data-bs-target="#collapse8" 
                aria-expanded="false" 
                aria-controls="collapse8"
            >
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png" 
                     class="fr-fic fr-dii" 
                     style="width: 15px; height: 15px; margin-right: 5px; margin-top: 5px;">
                Avances y Súper Avances
            </button>
        </h5>
    </div>

    <div id="collapse8" class="collapse" aria-labelledby="heading8" data-bs-parent="#accordion">
        <div class="card-body">
            <div class="card">

                <!-- 8.1 -->
                <div class="card-header" id="heading8_1">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_1" 
                            aria-expanded="false" 
                            aria-controls="collapse8_1"
                        >
                            ¿Que es un Avance en Efectivo y como puedo solicitarlo?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_1" class="collapse" aria-labelledby="heading8_1">
                    <div class="card-body box3-preguntas">
                        <p>Es un monto en dinero que puedes solicitar  en efectivo directamente en las cajas de Unimarc, Super 10  o también en el  wsp +569  58123297  por transferencia a tu cuenta bancaria. Puedes pedir desde $20.000 hasta $200.000, de acuerdo a tu cupo disponible en 3  y hasta 12 cuotas.*sujeto a evaluación de crédito al momento de solicitarlo</p>
                    </div>
                </div>

                <!-- 8.2 -->
                <div class="card-header" id="heading8_2">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_2" 
                            aria-expanded="false" 
                            aria-controls="collapse8_2"
                        >
                            ¿Cómo pido un Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_2" class="collapse" aria-labelledby="heading8_2">
                    <div class="card-body box3-preguntas">
                        <p>Pidelo directamente en las cajas Unimarc o Super 10 en efectivo o a traves del wsp +569  58123297 como transferencia a tu cuenta bancaria. Puedes pedir desde $20.000 hasta $200.000 en 3 hasta 12 cuotas.</p>
                        <p>Revisa en el wsp +569 58123297 tu monto disponible y simula tu cuota. *sujeto a evaluación de crédito al momento de solicitarlo.</p>
                    </div>
                </div>

                <!-- 8.3 -->
                <div class="card-header" id="heading8_3">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_3" 
                            aria-expanded="false" 
                            aria-controls="collapse8_3"
                        >
                            ¿Cuál es el costo de un Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_3" class="collapse" aria-labelledby="heading8_3">
                    <div class="card-body box3-preguntas">
                        <p>No hay costo por comision al girar un  avance. Infórmate de las tasas de interés vigente en unipay.cl</p>
                        <p>Los seguros asociados son voluntarios.</p>
                        <p>Este tipo de transacciones genera ITE: impuesto de timbres y estampillas de recaudación fiscal.</p>
                    </div>
                </div>

                <!-- 8.4 -->
                <div class="card-header" id="heading8_4">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_4" 
                            aria-expanded="false" 
                            aria-controls="collapse8_4"
                        >
                            ¿Qué es un Súper Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_4" class="collapse" aria-labelledby="heading8_4">
                    <div class="card-body box3-preguntas">
                        <p>Un Súper Avance es un monto adicional a tu línea de cupo asignado para compras, el cual corresponde a una campaña por un tiempo determinado y donde la oferta máxima puede ser de hasta $4.000.0000. Puedes girarlo entre 12 a 48 meses.</p>
                        <p>*Sujeto a evaluación de crédito al momento de solicitarlo.</p>
                    </div>
                </div>

                <!-- 8.5 -->
                <div class="card-header" id="heading8_5">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_5" 
                            aria-expanded="false" 
                            aria-controls="collapse8_5"
                        >
                            ¿Cómo pido un Súper Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_5" class="collapse" aria-labelledby="heading8_5">
                    <div class="card-body box3-preguntas">
                        <p>Puedes pedirlo al WhatsApp +569 58123297 como transferencia a tu cuenta bancaria o llámanos al 600 390 9001.</p>
                        <p>*Sujeto a evaluación de crédito al momento de solicitarlo</p>
                    </div>
                </div>

                <!-- 8.6 -->
                <div class="card-header" id="heading8_6">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_6" 
                            aria-expanded="false" 
                            aria-controls="collapse8_6"
                        >
                            ¿A qué cuenta puedo pedir el abono del Súper Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_6" class="collapse" aria-labelledby="heading8_6">
                    <div class="card-body box3-preguntas">
                        <p>Tu Súper Avance podrá ser abonado a la cuenta bancaria que indiques: cuenta corriente, cuenta Rut, cuenta vista o de ahorro según decidas, la cual debe ser de tu titularidad.</p>
                    </div>
                </div>

                <!-- 8.7 -->
                <div class="card-header" id="heading8_7">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_7" 
                            aria-expanded="false" 
                            aria-controls="collapse8_7"
                        >
                            ¿Cómo simulo un Súper Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_7" class="collapse" aria-labelledby="heading8_7">
                    <div class="card-body box3-preguntas">
                        <p>Puedes simular tu Súper Avance en el WhatsApp + 569 58123297 y elegir la cuota más conveniente para ti.</p>
                    </div>
                </div>

                <!-- 8.8 -->
                <div class="card-header" id="heading8_8">
                    <h5 class="mb-0">
                        <button 
                            class="btn btn-preguntas-custom collapsed" 
                            data-bs-toggle="collapse" 
                            data-bs-target="#collapse8_8" 
                            aria-expanded="false" 
                            aria-controls="collapse8_8"
                        >
                            ¿Cuál es el costo de un Súper Avance?
                        </button>
                    </h5>
                </div>

                <div id="collapse8_8" class="collapse" aria-labelledby="heading8_8">
                    <div class="card-body box3-preguntas">
                        <p>No hay costo por comisión al girar un Súper Avance. Infórmate de las tasas de interés vigente en unipay.cl Los seguros asociados son voluntarios</p>
                        <p>Este tipo de transacciones genera ITE: impuesto de timbres y estampillas de recaudación fiscal</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>


<div class="card">
    <div class="card-header" id="heading9" style="background:#683DF2;">

        <h5 class="mb-0">
            <button style="color: white;" aria-controls="collapse9" aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse9" data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii" data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                Bloqueos
            </button>
        </h5>

    </div>

    <div aria-labelledby="heading9" class="collapse" data-bs-parent="#accordion" id="collapse9">
        <div class="card-body">

            <div class="card">

                <div class="card-header" id="heading9_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse9_1" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse9_1" data-bs-toggle="collapse">
                            ¿Qué debo hacer en caso de extravío y/o robo de mi tarjeta?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading9_1" class="collapse" id="collapse9_1">
                    <div class="card-body box3-preguntas">
                        <p>Debes bloquear inmediatamente a través de nuestro WhatsApp +569 58123297 seleccionando la opción 6 y seguir las instrucciones o dar aviso llamando al 600 390 9000 opción 5
                        o llamar al Fono Emergencia 800 393030 opción 5.</p>
                    </div>
                </div>

                <div class="card-header" id="heading9_2">
                    <h5 class="mb-0">
                        <button aria-controls="collapse9_2" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse9_2" data-bs-toggle="collapse">
                            Tengo Bloqueada mi Unipay, ¿Cómo la desbloqueo?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading9_2" class="collapse" id="collapse9_2">
                    <div class="card-body box3-preguntas">
                        <p>Llámanos al 600 390 9000 y te  guiaremos en los pasos a seguir para desbloquear tu Unipay y puedas seguir usándola.</p>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>


<div class="card">
    <div class="card-header" id="heading10" style="background:#683DF2;">

        <h5 class="mb-0">
            <button style="color: white;" aria-controls="collapse10" aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse10" data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii" data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                Compras no presenciales
            </button>
        </h5>

    </div>

    <div aria-labelledby="heading10" class="collapse" data-bs-parent="#accordion" id="collapse10">
        <div class="card-body">

            <div class="card">

                <div class="card-header" id="heading10_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse10_1" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse10_1" data-bs-toggle="collapse">
                            Si no tengo tarjeta plástica, ¿Cómo compro en www.unimarc.cl?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading10_1" class="collapse" id="collapse10_1">
                    <div class="card-body box3-preguntas">
                        <p>Para comprar en unimarc.cl o en unired.cl con tu Unipay, sólo necesitas seleccionarnos como medio de pago. Ingresas tu rut y recibirás en tu celular una clave para confirmar el pago y ¡listo!</p>
                    </div>
                </div>

                <div class="card-header" id="heading10_2">
                    <h5 class="mb-0">
                        <button aria-controls="collapse10_2" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse10_2" data-bs-toggle="collapse">
                            Tengo que activar Unipay para las compras no presenciales
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading10_2" class="collapse" id="collapse10_2">
                    <div class="card-body box3-preguntas">
                        <p>Si ya has usado tu Unipay en cualquier supermercado presencialmente, estas listo para probar la experiencia de www.unimarc.cl con Unipay</p>
                        <p>Si aun no la usas y eres nuevo cliente de Unipay, al 3er dia habil desde que obtuviste tu tarjeta 100% digital podras usarla en www.unimarc.cl o en www.unired.cl.</p>
                        <p>Si presentas dudas en este proceso, llamanos al 600 390 9000.</p>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>


<div class="card">
    <div class="card-header" id="heading12" style="background:#683DF2;">

        <h5 class="mb-0">
            <button style="color: white;" aria-controls="collapse12" aria-expanded="false"
                class="btn btn-preguntas-custom collapsed"
                data-bs-target="#collapse12" data-bs-toggle="collapse">
                <img alt="desplegable" src="https://www.unipay.cl/api/descargaArchivo/desplegable.png"
                    class="fr-fic fr-dii" data-filetype="image/png"
                    style="width: 15px; height: 15px;margin-right: 5px;margin-top: 5px;">
                App Unipay
            </button>
        </h5>

    </div>

    <div aria-labelledby="heading12" class="collapse" data-bs-parent="#accordion" id="collapse12">
        <div class="card-body">

            <div class="card">

                <div class="card-header" id="heading12_1">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_1" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_1" data-bs-toggle="collapse">
                            ¿Cómo puedo acceder a la APP Unipay?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_1" class="collapse" id="collapse12_1">
                    <div class="card-body box3-preguntas">
                        <p>Se descarga como cualquier aplicación en tu teléfono a través de Google Play o App Store</p>
                    </div>
                </div>


                 <div class="card-header" id="heading12_2">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_2" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_2" data-bs-toggle="collapse">
                            ¿Cualquier modelo de smartphone es compatible?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_2" class="collapse" id="collapse12_2">
                    <div class="card-body box3-preguntas">
                        <p>Cualquier Smartphone  con acceso a su camara fotográfica y con un minimo de memoria disponible</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_3">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_3" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_3" data-bs-toggle="collapse">
                            ¿Debo otorgarle permisos especiales a la APP Unipay desde mi Smartphone?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_3" class="collapse" id="collapse12_3">
                    <div class="card-body box3-preguntas">
                        <p>Es necesario que apruebes los términos y condiciones y darle acceso a la camara fotográfica cuando te lo solicite. Esto nos permitirá verificar tu identidad de forma rápida y segura</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_4">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_4" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_4" data-bs-toggle="collapse">
                            ¿Cómo busco la aplicación de Unipay?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_4" class="collapse" id="collapse12_4">
                    <div class="card-body box3-preguntas">
                        <p>Buscala en la tienda de aplicaciones de tu teléfono, Google Play o App Store. Se llama Unipay, y el logo es negro.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_5">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_5" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_5" data-bs-toggle="collapse">
                            ¿Existe alguna recomendación para la descarga?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_5" class="collapse" id="collapse12_5">
                    <div class="card-body box3-preguntas">
                        <p>Idealmente que estés conectado a una red Wifi.</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_6">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_6" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_6" data-bs-toggle="collapse">
                            ¿Cualquier cliente Unipay puede descargar la APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_6" class="collapse" id="collapse12_6">
                    <div class="card-body box3-preguntas">
                        <p>Todos los clientes con una cuenta Unipay vigente sin bloqueos, pueden descargar la APP. Para ello deben hacerlo usando el telefono previamente registrado en Unipay.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_7">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_7" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_7" data-bs-toggle="collapse">
                            ¿Cómo funciona el proceso de registro en la App?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_7" class="collapse" id="collapse12_7">
                    <div class="card-body box3-preguntas">
                        <p>Una vez descargues la APP en tu celular, enviaremos un código a tu celular y al email que tienes registado en tu cuenta. Con ese código podrás crear tu clave de acceso y completar los datos solicitados. Ten tu cédula de identidad vigente a mano, ya que deberás fotografiarla y validar tu identidad con biometría facial. Te recomendamos hacerlo en un lugar tranquilo y bien iluminado, evitando tanto la luz directa del sol como la oscuridad.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_8">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_8" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_8" data-bs-toggle="collapse">
                            ¿Qué pasa si no me llegan los códigos?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_8" class="collapse" id="collapse12_8">
                    <div class="card-body box3-preguntas">
                        <p>Te recomendamos revisar tu buzón de correos no deseados y si continúan sin llegar, presiona reenviar códigos desde la App.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_9">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_9" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_9" data-bs-toggle="collapse">
                            ¿Puedo tener la APP Unipay descargada en varios teléfonos?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_9" class="collapse" id="collapse12_9">
                    <div class="card-body box3-preguntas">
                        <p>No, solo la podrás tener instalada en el teléfono registrado.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_10">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_10" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_10" data-bs-toggle="collapse">
                            ¿La APP necesita tener una clave de acceso?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_10" class="collapse" id="collapse12_10">
                    <div class="card-body box3-preguntas">
                        <p>Si, en el proceso de registro debes crear una clave de acceso. Si tu teléfono tiene lectura de huella o reconocimiento facial, lo podrás habilitar como mecanismo de ingreso a la APP.</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_11">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_11" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_11" data-bs-toggle="collapse">
                            ¿Puedo tener dos cuentas Unipay en un solo teléfono?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_11" class="collapse" id="collapse12_11">
                    <div class="card-body box3-preguntas">
                        <p>No, solo la podrás tener instalada en el teléfono registrado.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_12">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_12" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_12" data-bs-toggle="collapse">
                            ¿Qué funciones tiene esta APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_12" class="collapse" id="collapse12_12">
                    <div class="card-body box3-preguntas">
                        <p>Prinicipalmente te servirá para autorizar las compras que realices en Unimarc, Super 10 y Alvi. Debes indicar en caja que quieres pagar con código y debes dictar los 6 dígitos que te entrega la App. Si estás frente a una caja de autoservicio, debes seleccionar pagar con Unipay, luego seleccionas pagar con código y digitar los 6 dígitos que te entrega la APP.
Además en esta App, podrás ver en línea tu cupo disponible para compras, revisar tu oferta de Avances y Super Avances.</p>
                    </div>
                </div>




                <div class="card-header" id="heading12_13">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_13" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_13" data-bs-toggle="collapse">
                            ¿Puedo comprar en cuotas al usar la APP Unipay?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_13" class="collapse" id="collapse12_13">
                    <div class="card-body box3-preguntas">
                        <p>Si, recuerda que puedes pedir o seleccionar comprar en cuotas siempre.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_14">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_14" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_14" data-bs-toggle="collapse">
                            ¿Tiene un costo adicional usar o descargar la APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_14" class="collapse" id="collapse12_14">
                    <div class="card-body box3-preguntas">
                        <p>No, no tiene costos adicionales por uso o compras con Unipay.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_15">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_15" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_15" data-bs-toggle="collapse">
                            ¿Puedo seguir usando la Huella si descargo la APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_15" class="collapse" id="collapse12_15">
                    <div class="card-body box3-preguntas">
                        <p>Sí, puedes pagar con tu huella siempre que quieras. También puedes usar la App o tu tarjeta física si la tienes en tu poder, según te resulte más cómodo.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_16">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_16" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_16" data-bs-toggle="collapse">
                            ¿Se pueden reutilizar los códigos?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_16" class="collapse" id="collapse12_16">
                    <div class="card-body box3-preguntas">
                        <p>No, ya que el código solo dura un tiempo limitado y es para un solo uso.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_17">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_17" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_17" data-bs-toggle="collapse">
                            ¿Necesito tener Internet para usar la APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_17" class="collapse" id="collapse12_17">
                    <div class="card-body box3-preguntas">
                        <p>No, no necesitarás conexión a internet para obtener el código de autorizacion del pago. Para las otras funciones como revisar tu cupo en línea, si necesitas acceso a una red de internet.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_18">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_18" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_18" data-bs-toggle="collapse">
                            ¿Qué pasa si pierdo el teléfono en el que tengo registrada la App?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_18" class="collapse" id="collapse12_18">
                    <div class="card-body box3-preguntas">
                        <p>Debes llamar a nuestro Contact Center al 600 390 9000 para bloquear la APP. Marcando la opcion 7 del menú lograrás realizar este bloqueo.
Recuerda que no debes compartir tu clave de acceso con nadie y que desde Unipay nunca te llamaremos para solicitar tus claves o códigos.</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_19">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_19" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_19" data-bs-toggle="collapse">
                            ¿Cómo reactivo la APP si realicé el bloqueo?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_19" class="collapse" id="collapse12_19">
                    <div class="card-body box3-preguntas">
                        <p>Debes volver a realizar todo el proceso de descarga y registro en la App. En caso que recuperes tu celular debes ingresar con tu clave y deberás realizar el proceso de verificacion facial.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_20">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_20" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_20" data-bs-toggle="collapse">
                            ¿Las compras autorizadas con el código de la APP, aparecen igual en el estado de cuenta?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_20" class="collapse" id="collapse12_20">
                    <div class="card-body box3-preguntas">
                        <p>Si, podrás ver todas tus compras siempre en tu estado de cuenta.</p>
                    </div>
                </div>


                <div class="card-header" id="heading12_21">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_21" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_21" data-bs-toggle="collapse">
                            ¿Qué pasa si olvido mi PIN de seguridad para el uso? 
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_21" class="collapse" id="collapse12_21">
                    <div class="card-body box3-preguntas">
                        <p>Debes seleccinar "Olvidé mi clave" en la APP y seguir las instrucciones.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_22">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_22" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_22" data-bs-toggle="collapse">
                            ¿Qué pasa si olvido la clave de acceso a la APP?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_22" class="collapse" id="collapse12_22">
                    <div class="card-body box3-preguntas">
                        <p>Debes seleccionar "Recuperar clave" y seguir las instrucciones de la APP. Revisa en tu buzón de Correo No Deseado, ya que enviaremos a tu mail registrado un código.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_23">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_23" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_23" data-bs-toggle="collapse">
                            ¿Debo elegir sólo una forma de pagar con mi Unipay?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_23" class="collapse" id="collapse12_23">
                    <div class="card-body box3-preguntas">
                        <p>No, podrás usar el medio de pago que tu desees al momento de la compra.  Si un día usas tu código, no hay problema en que tu próxima compra sea con la huella, según te resulte más cómodo.</p>
                    </div>
                </div>



                <div class="card-header" id="heading12_24">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_24" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_24" data-bs-toggle="collapse">
                             Soy nuevo cliente Unipay ¿Puedo usar la app de inmediato?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_24" class="collapse" id="collapse12_24">
                    <div class="card-body box3-preguntas">
                        <p>Los nuevos clientes de Unipay, pueden descargar la App de inmediato, pero el código de autorización estará habilitado al día siguiente para aquellos que realizaron una firma o compra presencial con huella. Aquellos clientes que no han hecho uso de su huella digital quedarán habilitados en un plazo máximo de 3 días hábiles para el uso de la App.</p>
                    </div>
                </div>




                <div class="card-header" id="heading12_25">
                    <h5 class="mb-0">
                        <button aria-controls="collapse12_25" aria-expanded="false"
                            class="btn btn-preguntas-custom collapsed"
                            data-bs-target="#collapse12_25" data-bs-toggle="collapse">
                             ¿Puedo usar este código para comprar en Unimar.cl, en la App Unimarc o en Unired.cl?
                        </button>
                    </h5>
                </div>

                <div aria-labelledby="heading12_25" class="collapse" id="collapse12_25">
                    <div class="card-body box3-preguntas">
                        <p>No, este código solo te servirá para realizar compras presenciales en cualquier supermercado Unimarc, Super 10 o Alvi</p>
                    </div>
                </div>



                


                

            </div>

        </div>
    </div>
</div>






            </div><!-- /#accordion -->


             <!-- Información de contacto adicional -->
    <div class="faq-accordion__contact">
      <h3 class="faq-accordion__contact-title">¿No encontraste lo que buscabas?</h3>
      <p class="faq-accordion__contact-description">
        Contáctanos directamente y te ayudaremos a resolver todas tus dudas
      </p>
      <div class="faq-accordion__contact-buttons">
        <div class="faq-accordion__contact-button">
          <div class="faq-accordion__contact-button-title">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-iconos02.png" width="30" alt="telefono">
             Llámanos
          </div>
          <div class="faq-accordion__contact-button-number">600 390 9000</div>
        </div>
        <div class="faq-accordion__contact-button">
          <div class="faq-accordion__contact-button-title">
            <img src="https://www.unipay.cl/api/descargaArchivo/web-ws-iconos01.png" width="30" alt="whatsapp">
             WhatsApp
          </div>
          <div class="faq-accordion__contact-button-number">+569 58123297</div>
        </div>
      </div>
    </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


    
  </div>
</div>
